import { createContext, useContext } from "react";
import type { BankConnectSchema } from "bankconnect";

export const BankConnectContext = createContext<BankConnectSchema | null>(null);

export const useBankConnectContext = (): BankConnectSchema => {
  const context = useContext(BankConnectContext);
  if (context === null) {
    throw new Error("BankConnectContext used outside BankConnectContextProvider");
  }
  return context;
};
